import React, { useState } from 'react'
import './CategoryListing.css'
import { Link } from 'react-router-dom'

const CategoryListingContainer = ({ containerObject, templateName, contentId, dataZone }) => {
  const [containerObjectState, setContainerObjectState] = useState(containerObject && containerObject.results ? containerObject.results : "")
  return (
    <div>
 {containerObjectState && containerObject.results.length > 0 ? <>
      <div className='="row'>
        <h2 class="right-panel-heading">{containerObject && containerObject.currentCategoryName ? containerObject.currentCategoryName : ""}</h2>
      </div>
      <div className='row'>
        <div className='col-md-12'>
         
          <section className='c-category-tabs'>
            <ul id='myTab' className='nav nav-tabs d-mobile-hide' role='tablist'>
              <li className='nav-item' role='presentation'>
                <button class="nav-link active" id="ProductCategories-tab" data-bs-toggle="tab" data-bs-target="#ProductCategories" type="button" role="tab" aria-controls="ProductCategories" aria-selected="true">Product Categories</button>
              </li>
              <li className='nav-item' role='presentation'>
                <button class="nav-link" id="FeaturedProducts-tab" data-bs-toggle="tab" data-bs-target="#FeaturedProducts" type="button" role="tab" aria-controls="FeaturedProducts" aria-selected="false" tabindex="-1">Featured Products</button>
              </li>
            </ul>
            <div class="tab-content c-tab-wrapper " id="myTabContent-">
              <div class="tab-pane fade show active" id="ProductCategories" role="tabpanel" aria-labelledby="Product Categories-tab" tabindex="0">
                <div className='row'>
                  {containerObjectState.map((item) => {
                    return (
                      <>
                        <div className='col-md-3 col-6'>
                          <Link className='c-category-list' to={item["navigationState"] ? item["navigationState"] : ""}>
                            <img fetchpriority="high" className='' alt={item["label"] ? item["label"] : ""} src={`https://www.carolina.com${item.properties["category.thumbnail_url"]}` ? `https://www.carolina.com${item.properties["category.thumbnail_url"]}` : ""} />
                            <p className='c-category-title'>{item["label"] ? item["label"] : ""}</p>
                          </Link>
                        </div>

                      </>
                    )
                  })}
                </div>
              </div>
              <div class="tab-pane fade show" id="FeaturedProducts" role="tabpanel" aria-labelledby="Product Categories-tab" tabindex="0">
                <div class="row px-1">
                  <h1 className='fs-6 text-center text-dark'>THERE IS NO PRODUCT AVAILABLE</h1>
                </div>
              </div>
            </div>
          </section> 
        </div>
      </div> </>: "" }

    </div>
  )
}

export default CategoryListingContainer